<div class="container">
  <div class="content-wrapper" #wrapper>
    <app-logo class="logo" [variant]="'full'"></app-logo>

    <div class="title">Admin Portal Sign In</div>
    <div class="sub-title">Manage suppliers, applications, and more with the Admin Portal.</div>

    @if (hasError()) {
      <div class="login-error">{{ hasError() }}</div>
    }

    @if (isSubmitting()) {
      <mat-spinner diameter="32"></mat-spinner>
    } @else {
      <asl-google-signin-button
        type="standard"
        [size]="buttonSize()"
        [width]="buttonWidth()"
      ></asl-google-signin-button>
    }

    <p class="helper">
      Have questions? Contact us at
      <a href="mailto:support@transendfinancial.com" class="app-text-link"
        >support&#64;transendfinancial.com</a
      >
    </p>
  </div>
</div>
